<template>
<div>
  <v-layout row justify-center>
      <!-- @click="getCurrentElement(investigador.id)" -->
    <v-dialog v-model="dialog" persistent max-width="450">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <!-- <v-card-title class="headline">localInv: {{this.investigador.titulo}} </v-card-title> -->

          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="nombre" label="Nombre completo*" required :rules="[v => !!v || 'Campo requerido']"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="correo" label="Correo*" required :rules="[v => !!v || 'Campo requerido', v => /.+@.+/.test(v) || 'Elige un correo válido']"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="comentarios" label="Comentarios*" required :rules="[v => !!v || 'Campo requerido']"></v-textarea>
              </v-flex>
              
              <v-checkbox
                v-model="checkbox"
                :rules="[v => !!v || 'Debes aceptar para continuar!']"
                label="Aceptar"
                required
              ></v-checkbox>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="green darken-1" :disabled="!valid" flat="flat" @click="sendEmail(), validate">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</div>
</template>

<script>
export default {
  name: 'investigador-email',
  data(){
    return{
      valid: true,
      dialog: false,
      nombre: '',
      correo: '',
      comentarios: '',
      investigadorLocal: this.investigador
    }
  },
  methods:{
    sendEmail: function(){
      window.open(`mailto:seicti@cocyted.gob.mx?subject=Me interesa contactar al investigador&body=Nombre: ${this.nombre},%0D%0ACorreo: ${this.correo},%0D%0AMensaje: ${this.comentarios},%0D%0A%0D%0AInvestigador:%0D%0AFolio: ${this.investigador.persona.folio}%0D%0ANombre: ${this.investigador.persona.nombre_completo}%0D%0AProyecto: ${this.investigador.titulo ? this.investigador.titulo : "El título está nulo"}`);
      this.nombre= '',
      this.correo= '',
      this.comentarios= '',
      this.dialog = false;
    },
    validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
    },
  },
  props:{
    show: Boolean,
    investigadorId: Number,
    investigador: Object
  },
  watch:{
    show: function (value) {
      this.dialog = value
    },
    dialog: function (value) {
      this.$emit('update:show', value);
    }
  }
}
</script>